import BasicRootStore from 'Core/stores/basicRootStore/BasicRootStore'

import * as constants from 'Portals/Customer/constants'
import {
	AccountCategoryStore,
	AnalyticStore,
	AuditStore,
	AuthStore,
	BackupDocumentStore,
	BiohazardousManifestStore,
	CompanyCategoryStore,
	CustomerInvoiceStore,
	DashboardStore,
	HelpCenterStore,
	KpiStore,
	LocationByPeriodsStore,
	LocationStore,
	ManifestStore,
	MetadataStore,
	MetricByPeriodsStore,
	MouStore,
	OrderStore,
	ProfileStore,
	// INJECT_FROM_PLOP_TABLELIST__IMPORT_STORE
	PurchaseOrderStore,
	RegistrationDocumentStore,
	ReportStore,
	ServiceLocationStore,
	SiteDocumentStore,
	TreatmentCategoryStore,
	TreatmentMethodStore,
	WastestreamStore
} from 'Portals/Customer/stores'

export class RootStore extends BasicRootStore {
	// INJECT_FROM_PLOP_TABLELIST__DECLARE_STORE
	[constants.STORE_PURCHASE_ORDER]: PurchaseOrderStore;
	[constants.STORE_AUTH]: AuthStore;
	[constants.STORE_CUSTOMER_INVOICE]: CustomerInvoiceStore;
	[constants.STORE_SITE_DOCUMENT]: SiteDocumentStore;
	[constants.STORE_BACKUP_DOCUMENT]: BackupDocumentStore;
	[constants.STORE_BIOHAZARDOUS_MANIFEST]: BiohazardousManifestStore;
	[constants.STORE_WASTESTREAM]: WastestreamStore;
	[constants.STORE_ORDER]: OrderStore;
	[constants.STORE_REPORT]: ReportStore;
	[constants.STORE_COMPANY_CATEGORY]: CompanyCategoryStore;
	[constants.STORE_ACCOUNT_CATEGORY]: AccountCategoryStore;
	[constants.STORE_TREATMENT_CATEGORY]: TreatmentCategoryStore;
	[constants.STORE_TREATMENT_METHOD]: TreatmentMethodStore;
	[constants.STORE_DASHBOARD]: DashboardStore;
	[constants.STORE_MANIFEST]: ManifestStore;
	[constants.STORE_MOU]: MouStore;
	[constants.STORE_HELP_CENTER]: HelpCenterStore;
	[constants.STORE_METADATA]: MetadataStore;
	[constants.STORE_ANALYTIC]: AnalyticStore;
	[constants.STORE_PROFILE]: ProfileStore;
	[constants.STORE_METRIC_BY_PERIODS]: MetricByPeriodsStore;
	[constants.STORE_LOCATION]: LocationStore;
	[constants.STORE_KPI]: KpiStore;
	[constants.STORE_LOCATION_BY_PERIODS]: LocationByPeriodsStore;
	[constants.STORE_AUDIT]: AuditStore;
	[constants.STORE_REGISTRATION_DOCUMENT]: RegistrationDocumentStore;
	[constants.STORE_SERVICE_LOCATION]: ServiceLocationStore

	constructor() {
		super()
		Object.assign(this, {
			// INJECT_FROM_PLOP_TABLELIST__INITIALIZE_STORE
			[constants.STORE_PURCHASE_ORDER]: new PurchaseOrderStore(this),
			[constants.STORE_AUTH]: new AuthStore(this),
			[constants.STORE_CUSTOMER_INVOICE]: new CustomerInvoiceStore(this),
			[constants.STORE_SITE_DOCUMENT]: new SiteDocumentStore(this),
			[constants.STORE_BACKUP_DOCUMENT]: new BackupDocumentStore(this),
			[constants.STORE_BIOHAZARDOUS_MANIFEST]: new BiohazardousManifestStore(this),
			[constants.STORE_WASTESTREAM]: new WastestreamStore(this),
			[constants.STORE_ORDER]: new OrderStore(this),
			[constants.STORE_REPORT]: new ReportStore(this),
			[constants.STORE_COMPANY_CATEGORY]: new CompanyCategoryStore(this),
			[constants.STORE_ACCOUNT_CATEGORY]: new AccountCategoryStore(this),
			[constants.STORE_TREATMENT_CATEGORY]: new TreatmentCategoryStore(this),
			[constants.STORE_TREATMENT_METHOD]: new TreatmentMethodStore(this),
			[constants.STORE_DASHBOARD]: new DashboardStore(this),
			[constants.STORE_MANIFEST]: new ManifestStore(this),
			[constants.STORE_MOU]: new MouStore(this),
			[constants.STORE_HELP_CENTER]: new HelpCenterStore(this),
			[constants.STORE_METADATA]: new MetadataStore(this),
			[constants.STORE_ANALYTIC]: new AnalyticStore(this),
			[constants.STORE_PROFILE]: new ProfileStore(this),
			[constants.STORE_METRIC_BY_PERIODS]: new MetricByPeriodsStore(this),
			[constants.STORE_KPI]: new KpiStore(this),
			[constants.STORE_LOCATION]: new LocationStore(this),
			[constants.STORE_LOCATION_BY_PERIODS]: new LocationByPeriodsStore(this),
			[constants.STORE_AUDIT]: new AuditStore(this),
			[constants.STORE_REGISTRATION_DOCUMENT]: new RegistrationDocumentStore(this),
			[constants.STORE_SERVICE_LOCATION]: new ServiceLocationStore(this)
		})
	}
}
